import React, { useEffect } from "react";
import Navbar from "../components/layout/navbar";
import Footer from "../components/layout/footer";
import Pricingbanner from "../components/pages/Pricing/pricingbanner";
import Exclusivepkg from "../components/pages/Pricing/exclusivepkg";

const Pricing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <Pricingbanner />
      <Exclusivepkg />
      <Footer />
    </>
  );
};

export default Pricing;
